import { SignIn } from "@clerk/clerk-react";
import { createRoute } from "@tanstack/react-router";

import { AtlasPlate } from "../components/brand/atlas-plate.js";

import { rootRoute } from "./__root.js";

/**
 * Staff auth surfaces. A two-column split: the Clerk `<SignIn>` stays
 * fully functional and centred in the right column, while the left
 * column carries the tenant-neutral L30 AtlasPlate brand device (the
 * staff-app answer to the portal's Transition33 welcome — see
 * platform-assessment X7). The plate collapses on narrow viewports so
 * the form is never crowded on mobile.
 */
function AuthLayout({ path }: { path: "/sign-in" | "/sign-up" }) {
  return (
    <div className="grid h-screen w-full lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)]">
      {/* Brand panel — decorative, hidden below lg where space is tight. */}
      <div className="relative hidden border-r border lg:block">
        <AtlasPlate />
      </div>

      {/* Form column — the SignIn is always centred and interactive. */}
      <div className="flex h-screen items-center justify-center bg-surface-muted px-6">
        <SignIn routing="path" path={path} signUpUrl="/sign-up" afterSignInUrl="/dashboard" />
      </div>
    </div>
  );
}

export const signInRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign-in/$",
  component: () => <AuthLayout path="/sign-in" />,
});

export const signUpRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/sign-up/$",
  component: () => <AuthLayout path="/sign-up" />,
});
